import { useConversationsRequests } from "../../apis/conversations/useConversationsRequests";

export const useConversationsHandlers = () => {
    const { getConversationByConversationId, updateConversations, createNewConversation, updateConversationStar } = useConversationsRequests()

    const getConversationByConversationIdHandler = async (id: any) => {
        if(!id) return { conversation: [] }
        const result = await getConversationByConversationId(id)
        if(result) return result
    }

    const syncConversationWithBackendHandler = async (
        _id: any,
        isRead: boolean,
        isSent?: boolean,
        dateTimestamp?: any,
        text?: string,
        analytics?: { source?: 'inbox' | 'connection_profile' | 'bulk' | string; has_template?: boolean; message_id?: string },
        recentMessages?: Array<{ sender: string; text: string }>
    ) => {
        const result = await updateConversations({
            type: "background-update",
            conversations: [
                { _id, isRead, isSent, dateTimestamp, text, ...(analytics ? { analytics } : {}), ...(recentMessages?.length ? { recentMessages } : {}) }
            ]
        })

        if(result) return result
    }

    const createNewConversationHandler = async (
        profileId: any,
        dateTimestamp: any,
        text: any,
        conversationId: any,
        analytics?: { source?: 'inbox' | 'connection_profile' | 'bulk' | string; has_template?: boolean; message_id?: string }
    ) => {
        const body = {
            conversation: {
                participants: [{
                    memberId: profileId
                }],
                messages:[{
                    dateTimestamp,
                    messageContent: {
                        text
                    },
                    isSent: true,
                }],
                conversationId,
                isRead: true,
                isSent: true,
                isArchived: false,
                ...(analytics ? { analytics } : {})
            }
        }
        await createNewConversation(body)
    }

    const updateConversationStarHandler = async (conversationId: string, isStarred: boolean) => {
        if (!conversationId) return
        const result = await updateConversationStar(conversationId, isStarred)
        if (result) return result
    }

    return {
        getConversationByConversationIdHandler,
        syncConversationWithBackendHandler,
        createNewConversationHandler,
        updateConversationStarHandler
    };
}
